// Canaux d'aide directe proposés à la fin de l'onboarding (et ailleurs).
//
// Un canal laissé vide est simplement masqué (le funnel ne montre que les
// boutons dont le lien est renseigné) — jamais un lien inventé.
//
// Formats attendus :
//   whatsapp : https://wa.me/1XXXXXXXXXX   (numéro au format international, sans +)
//   discord  : https://discord.gg/xxxxxxxx   (invitation permanente de préférence)
//
// WhatsApp vient de legal.js (COMPANY) pour n'avoir qu'UNE source : c'est
// notre WhatsApp Business, LE canal de contact et de résiliation depuis le
// 26/09/2026 (plus de formulaire). Telegram est retiré : t.me/selfcntrl ne
// pointait sur aucun compte. Discord est le serveur communautaire.
import { COMPANY } from './legal'

export const SUPPORT = {
  whatsapp: COMPANY.whatsapp || '',
  // Invitation permanente du serveur communautaire (cf. CTRL_ALL/discord-server).
  discord: 'https://discord.gg/tS3yJFNvtW'
}

// Les canaux réellement configurés, dans l'ordre d'affichage.
export function supportChannels () {
  return [
    { key: 'whatsapp', href: SUPPORT.whatsapp },
    { key: 'discord', href: SUPPORT.discord }
  ].filter(c => c.href && c.href.trim())
}

// Lien WhatsApp avec un message pré-rempli (résiliation, aide…). Sans texte,
// le lien nu.
export function whatsappLink (text) {
  if (!SUPPORT.whatsapp) return ''
  return text ? `${SUPPORT.whatsapp}?text=${encodeURIComponent(text)}` : SUPPORT.whatsapp
}
